/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, withStyles } from "@material-ui/core";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import Button from "components/CustomButtons/Button.jsx";

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

function Footer({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div>
          <Button style={{ color:"#4BB64B"}} href="https://www.linkedin.com/in/sandtonglobal/" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
            <i className={"fab fa-linkedin"} />
          </Button>
          <Button  style={{ color:"#4BB64B"}}  href="https://twitter.com/Sandton_Global" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
            <i className={"fab fa-twitter"} />
          </Button>
          <Button  style={{ color:"#4BB64B"}}  href="https://www.instagram.com/sandtonglobal/" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
            <i className={"fab fa-instagram"} />
          </Button>
          {/* <Button  style={{ color:"#4BB64B"}}  href="https://medium.com/@sandtonglobal" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
            <i className={"fab fa-medium"} />
          </Button> */}
          <Button  style={{ color:"#4BB64B"}}  href="https://www.facebook.com/sandtonglobal/" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
            <i className={"fab fa-facebook"} />
          </Button>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx